import { Box, Typography } from "@mui/material";

interface Props {
	total: number;
}

export const ProductsHistorySummary = ({ total }: Props) => (
	<Box sx={{ px: 0.5 }}>
		<Typography variant="caption" color="text.secondary">
			Total: {total.toLocaleString()} campaigns
		</Typography>
	</Box>
);
